import { apiCall } from "api-calls/api-call"
import { CountryMultiplierDto, CreateCountryMultiplierDto } from "../store/types"
import {
  getMockCountryMultipliers,
  getMockCountryMultiplierById,
  createMockCountryMultiplier,
  updateMockCountryMultiplier,
  deleteMockCountryMultiplier,
} from "./country-multipliers.mock"

const USE_MOCK_DATA = false

export const getAllCountryMultipliers = async(): Promise<CountryMultiplierDto[]> => {
  if (USE_MOCK_DATA) {
    return getMockCountryMultipliers()
  }

  return apiCall({
    method: "GET",
    path: "games-v2/country-multipliers",
  })
}

export const getCountryMultiplierById = async(id: string): Promise<CountryMultiplierDto> => {
  if (USE_MOCK_DATA) {
    return getMockCountryMultiplierById(id)
  }

  return apiCall({
    method: "GET",
    path: `games-v2/country-multipliers/${id}`,
  })
}

export const createCountryMultiplier = async(data: CreateCountryMultiplierDto): Promise<CountryMultiplierDto> => {
  if (USE_MOCK_DATA) {
    return createMockCountryMultiplier(data)
  }

  return apiCall({
    method: "POST",
    path: "games-v2/country-multipliers",
    body: data,
  })
}

export const updateCountryMultiplier = async(id: string, data: CreateCountryMultiplierDto): Promise<CountryMultiplierDto> => {
  if (USE_MOCK_DATA) {
    return updateMockCountryMultiplier(id, data)
  }

  return apiCall({
    method: "PUT",
    path: `games-v2/country-multipliers/${id}`,
    body: data,
  })
}

export const deleteCountryMultiplier = async(id: string): Promise<void> => {
  if (USE_MOCK_DATA) {
    return deleteMockCountryMultiplier(id)
  }

  return apiCall({
    method: "DELETE",
    path: `games-v2/country-multipliers/${id}`,
  })
}
